import { makeStyles } from "@mui/styles";
import theme from "src/theme";

export const useStyles = makeStyles({
    wrapperBet: {
        display: "flex",
        alignItems: "center",
        paddingLeft: 16,
        [theme.breakpoints.down("lg")]: {
            paddingLeft: 0,
        },
    },
    coinIcon: {
        width: 24,
        height: 24,
        objectFit: "contain",
        marginRight: 8,
        [theme.breakpoints.down("lg")]: {
            width: 17,
            height: 17,
        },
    },
    amount: {
        fontSize: 20,
        fontWeight: 400,
        lineHeight: "24px",
        color: "#fff",
        textShadow: "1px 1px 0px 0px rgba(31, 29, 25, 1)",
        background:
            "linear-gradient(180deg, #FF9604 -0.31%, #FFE522 11.9%, #FFFFC1 36.23%, #FFBB1B 65.11%, #E28800 65.12%, #E9A600 88.87%)",
        "-webkit-background-clip": "text",
        "-webkit-text-fill-color": "transparent",
        [theme.breakpoints.down("lg")]: {
            fontSize: 14,
            fontWeight: 700,
            lineHeight: "16.8px",
        },
    },
    amountIsFree: {
        textShadow: "1px 1px 0px 0px rgba(255, 255, 255, 1)",
        background:
            "linear-gradient(180deg, #DDDDDD -0.31%, #EEEEEE 11.9%, #FFFFFF 36.23%, #FCFCFC 65.11%, #E2E2E2 65.12%, #AAAAAA 88.87%)",
        "-webkit-background-clip": "text",
        "-webkit-text-fill-color": "transparent",
    }
});
